const ExploreTabIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="none"
      viewBox="0 0 17 17"
      className={className}
    >
      <ellipse
        cx="7.629"
        cy="7.673"
        stroke="currentColor"
        stroke-width="1.5"
        rx="6.879"
        ry="6.923"
      />
      <path
        fill="currentColor"
        d="M15.689 16.716a1.057 1.057 0 0 1-.712-.308l-1.629-1.904a.87.87 0 0 1-.064-1.217.78.78 0 0 1 1.11 0l2.049 1.64c.295.301.386.75.232 1.144a1.068 1.068 0 0 1-.944.68l-.042-.035Z"
      />
    </svg>
  );
};

export default ExploreTabIcon;
